import React from 'react';

export default function Robin() {
    return (
        <article>
            <p>Robin is a Toronto based yoga, movement and mindfulness instructor with over 10 years experience.</p>

            <p>She is passionate about working together with clients to find the tools they need to create a fulfilling movement practice and live a more balanced life. Robin also holds a B.Sc. in psychology from the University of Toronto and an M.A. in Spiritual Care and psychotherapy from Laurier University. As such, she is committed to teaching yoga and movement as a means to support both physical and mental wellbeing.</p>

            <p>She lives in Leslieville with her golden retriever pup, Juno.</p>
        </article>
    )
};
